<script>
import SelectCourse from './SelectCourse.vue'
import { ParamsApi } from '@/utils/http'
export default {
  name: 'NormInfo',
  components: { SelectCourse },
  data() {
    return {
      equipmentList: [
        { id: 1, name: '其他' },
        { id: 2, name: '键盘' },
        { id: 4, name: '鼠标' },
        { id: 8, name: '触摸屏' },
        { id: 16, name: '全部' },
      ],
      addressOptions: [],
      selectCourse: {
        visible: false,
      },
      form: {
        contentName: sessionStorage.getItem('currentName'),
        regionName: '全国',
        data: {
          name: '',
          isDefault: true,
          deviceType: [16],
          regionId: 0,
          normTag: undefined,
        },
        rules: {
          regionId: [{ required: true, message: '请选择应用区域', trigger: 'change' }],
          deviceType: [{ required: true, message: '请选择应用区域', trigger: 'change' }],
          name: [{ required: true, message: '请输入常模名称', trigger: 'blur' }],
          isDefault: [{ required: true, message: '请选择是否默认常模', trigger: 'blur' }],
          normTag: [{ required: true, message: '请选择应用人群', trigger: 'change' }],
        },
      },
    }
  },
  computed: {
    addCourseName() {
      if (this.form.data.courses.length) {
        return this.form.data.courses.map((v) => v.name).join('，')
      }
      return '全部'
    },
  },
  mounted() {
    const normInfo = this.$store.getters['content/getNormInfo']()

    for (let key in this.form.data) {
      if (typeof normInfo[key] !== 'undefined') {
        this.form.data[key] = normInfo[key]
      }
    }
    if (normInfo.regionName !== undefined) {
      this.form.regionName = normInfo.regionName
    }
    this.getAddressList()
  },
  methods: {
    async saveLabelNorm(value) {
      const params = {
        key: 'NormTag',
        valueType: 2,
        remark: '常模应用人群配置',
        ...(this.normTagData || {}),
        value,
      }
      await ParamsApi.editRecord(params)
    },
    changeCustom() {
      let inputValue = ''
      this.$confirm({
        icon: () => '',
        title: '自定义标签',
        content: (h) =>
          h('a-input', {
            props: {
              maxLength: 10,
              placeholder: '请输入内容',
            },
            on: {
              change: (e) => {
                inputValue = e.target.value
              },
            },
          }),
        onOk: () => {
          this.form.normTags.push(inputValue)
          this.form.data.normTag = inputValue
          this.saveLabelNorm(JSON.stringify(this.form.normTags))
        },
      })
    },
    async getModeNorms() {
      const { data } = await this.$http.Base.getModelByKey({ key: 'NormTag' })
      this.normTagData = data
      if (data.enabled) {
        this.form.normTags = JSON.parse(data.value)
      }
    },
    confirmSelectCourse(courses) {
      this.form.data.courses = courses
    },
    openSelectCourse() {
      this.selectCourse.visible = true
    },
    /**
     * 获取地址
     * @param id 查询的省市区
     */
    getAddressList(id) {
      return new Promise((resolve, reject) => {
        this.$http.Mechanism.address({ parentId: id || 0 }).then((res) => {
          const { data, status, message } = res
          if (id) {
            resolve(
              data.map((v) => {
                return {
                  id: v.id,
                  value: v.id,
                  label: v.name,
                  isLeaf: v.level === 4,
                  loading: false,
                }
              })
            )
          } else {
            let str = {
              id: 0,
              name: '全国',
              isLeaf: true,
              loading: false,
            }
            data.unshift(str)
            this.addressOptions = data.map((v) => {
              return {
                id: v.id,
                value: v.id,
                label: v.name,
                isLeaf: v.id === 0,
                loading: false,
              }
            })
          }
          return
        })
      })
    },
    addressLoadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      return this.getAddressList(targetOption.value).then((data) => {
        targetOption.loading = false
        targetOption.children = data
        this.addressOptions = [...this.addressOptions]
        return data
      })
    },
    addressChange(val) {
      this.form.data.regionId = val[val.length - 1]
    },
  },
}
</script>

<template>
  <a-form-model ref="ruleForm" :model="form.data" :rules="form.rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
    <a-form-model-item required label="游戏名称">
      <a-input disabled v-model="form.contentName" />
    </a-form-model-item>
    <a-form-model-item label="常模名称" prop="name">
      <a-input v-model.trim="form.data.name" allowClear :maxLength="15" placeholder="请输入" />
    </a-form-model-item>
    <a-form-model-item label="应用设备" prop="deviceType">
      <a-select allowClear mode="multiple" disabled v-model="form.data.deviceType" placeholder="请选择">
        <a-select-option :value="item.id" v-for="item in equipmentList" :key="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="应用区域" prop="regionId">
      <input type="hidden" v-model="form.data.regionId" />
      <a-cascader
        :options="addressOptions"
        :class="form.regionName && 'echo'"
        :load-data="addressLoadData"
        @change="addressChange"
        :placeholder="form.regionName ? form.regionName : '请选择应用区域'"
        change-on-select
        allowClear
      />
    </a-form-model-item>
    <a-form-model-item label="是否默认常模" prop="isDefault">
      <a-radio-group v-model="form.data.isDefault">
        <a-radio :value="true">是</a-radio>
        <a-radio :value="false">否</a-radio>
      </a-radio-group>
    </a-form-model-item>
    <select-course v-model="selectCourse.visible" :courses="form.data.courses" @ok="confirmSelectCourse" />
  </a-form-model>
</template>
<style scoped lang="less">
.ant-form {
  max-width: 800px;
  margin: 24px auto 48px;

  /deep/.echo .ant-cascader-input::placeholder {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
  }
}
.course-input ::v-deep .ant-input:not(:last-child) {
  padding-right: 84px;
  text-overflow: ellipsis;
}
.custom-label {
  color: var(--color);
}
</style>
